import React from 'react';
import PropTypes from 'prop-types';
import './llptradedetails.css';
const LlpTradeDetails = ({ config }) => {
  return (
    <div className={`info`}>
      {config && (
        <div className="title-wrapper">
          <span className={`title ${config.titleClassName}`}>{config.title}</span>
          <span className={`data ${config.dataClassName}`}>{config.data}</span>
          <span className={`example ${config.exampleClassName}`}>{config.example}</span>
        </div>
      )}
    </div>
  );
};

LlpTradeDetails.propTypes = {
  viewFor: PropTypes.string,
  config: PropTypes.array
};

export default LlpTradeDetails;
